<!--<div class="left-bar-login">-->
<!--</div>-->
<div class="right-bar-login">
  <form class="form" [formGroup]="form">
    <div class="item logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="item" [class.error]="passwordCtrl.touched && passwordCtrl.errors">
      <label for="password" class="label required">введите новый пароль</label>
      <input class="input" type="password" id="password" placeholder="Пароль" [formControl]="passwordCtrl">
      <span class="error-message" *ngIf="passwordCtrl.touched && passwordCtrl.errors"> пароль слишком простой (мин. 6 символов, обязательно цифры и буквы)</span>
    </div>
    <div class="item" [class.error]="(passwordConfirmCtrl.value !== passwordCtrl.value && passwordConfirmCtrl.touched) || (passwordConfirmCtrl.touched && passwordConfirmCtrl.errors)">
      <label for="password-confirm"  class="label required">подтвердите новый пароль</label>
      <input class="input" type="password" id="password-confirm" placeholder="Повторите пароль"
             [formControl]="passwordConfirmCtrl">
    </div>
    <div class="error-message" *ngIf="errorMessage">{{errorMessage}}</div>
    <div class="error-message"
         *ngIf="passwordConfirmCtrl.touched && passwordCtrl.touched && passwordCtrl.value !== passwordConfirmCtrl.value && passwordCtrl.value && passwordConfirmCtrl.value">
      Введенные пароли не соответствуют
    </div>
    <!--<div class="error-message"-->
         <!--*ngIf="(passwordCtrl.touched && passwordCtrl.value && passwordCtrl.errors) || (passwordConfirmCtrl.touched && passwordConfirmCtrl.value && passwordConfirmCtrl.errors)">-->
      <!--мин. 6 символов, обязательно цифры и буквы-->
    <!--</div>-->
    <div class="btn-wrapper">
      <button class="button" (click)="onSubmit()"
              [disabled]="isSubmitting || (passwordConfirmCtrl.touched && passwordCtrl.touched && passwordCtrl.value !== passwordConfirmCtrl.value)">
        Продолжить
      </button>
    </div>
  </form>
</div>
